<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section epub:type="dedication" role="doc-dedication">
<p class="DED" id="ded"><span aria-label="v" id="pg_v" role="doc-pagebreak">For all the wounded warriors, veterans, and active-duty military around the world. Thank you for your service.</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?719224bd